import { type OnDestroy, Component, inject } from '@angular/core';
import {FirebaseService} from '../../core/services/firebase.service';
import {Subscription} from 'rxjs';
import { CateringMenuTemplateComponent } from '../menu/catering-menu-template/catering-menu-template.component';

@Component({
    selector: 'app-home-catering',
    templateUrl: './home-catering.component.html',
    styleUrls: ['./home-catering.component.scss'],
    imports: [CateringMenuTemplateComponent]
})
export class HomeCateringComponent implements OnDestroy {
    private firebaseService = inject(FirebaseService);

    cateringMenuItems: unknown[] = [];
    subscriptions: Subscription = new Subscription();

    mouseEnter(_e: unknown) {
        this.firebaseService.setFloatButton(true);
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

}
